import {
    Bot,
    CalendarCheck,
    CalendarDays,
    ClipboardList,
    ContactRound,
    createIcons,
    CreditCard,
    Globe,
    Handshake,
    Heart,
    MessageCircleMore,
    MessagesSquare,
    Send,
    Sparkles,
} from 'lucide';

createIcons({
    icons: {
        Bot,
        CalendarCheck,
        CalendarDays,
        ClipboardList,
        ContactRound,
        CreditCard,
        Globe,
        Handshake,
        Heart,
        MessageCircleMore,
        MessagesSquare,
        Send,
        Sparkles,
    },
});
